import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class AtLeastOneCombinationWasChosenValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const combos = stacking.getCheckedCombinations();

        if (isEmpty(combos)) {
            this.addError('There must be at least 1 combination selected if MLB Team Stacking is enabled.');
        }
    }
}

export default AtLeastOneCombinationWasChosenValidator;
